import {Dialog} from "@mui/material";
import {CustomCloseModal} from "../../../../../_fri/components/CustomCloseModal/CustomCloseModal";
import {EcommerceDashboardModalFIndUserContext} from "./EcommerceDashboardModalFIndUserContext";
import {Transaction} from "../../../../../store/api/interface/ecommerce";
interface IModalFindUser{
    show:boolean
    close: ()=> void
    openLoader: ()=> void
    setTransaction: (value: Transaction)=> void
    valuePayment:string

}
export const EcommerceDashboardModalFindUser = ({show, close, openLoader, setTransaction,valuePayment}:IModalFindUser) => {
    return (
        <Dialog open={show} maxWidth={'xs'}>
            <CustomCloseModal onClickClose={close} title={'Esperando pago de compra #145'}/>
            <EcommerceDashboardModalFIndUserContext close={close} openModalLoader={openLoader} setTransaction={setTransaction} valuePayment={valuePayment} />
        </Dialog>
    );
};